/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SetSlackUserInput = {
    personId?: string | null | undefined;
    slackId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type SetSlackUserMutationVariables = {
    input: SetSlackUserInput;
};
export type SetSlackUserMutationResponse = {
    readonly setSlackUser: {
        readonly viewer: {
            readonly slackId: string | null;
        } | null;
        readonly person: {
            readonly slackId: string | null;
        } | null;
    } | null;
};
export type SetSlackUserMutation = {
    readonly response: SetSlackUserMutationResponse;
    readonly variables: SetSlackUserMutationVariables;
};



/*
mutation SetSlackUserMutation(
  $input: SetSlackUserInput!
) {
  setSlackUser(input: $input) {
    viewer {
      slackId
      id
    }
    person {
      slackId
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetSlackUserInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slackId",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetSlackUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserPayload",
        "kind": "LinkedField",
        "name": "setSlackUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetSlackUserMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SetSlackUserPayload",
        "kind": "LinkedField",
        "name": "setSlackUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SetSlackUserMutation",
    "operationKind": "mutation",
    "text": "mutation SetSlackUserMutation(\n  $input: SetSlackUserInput!\n) {\n  setSlackUser(input: $input) {\n    viewer {\n      slackId\n      id\n    }\n    person {\n      slackId\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '3503234264c18dbea5c79f5183f8874e';
export default node;
